import { useAllowPreview } from 'utils/hooks/useAllowPreview';
import { DCB_CUSTOM_TEXT_TOKENS_PREVIEW_FLAG } from '../constants';

export const useTokensFeaturePreview = () => useAllowPreview(DCB_CUSTOM_TEXT_TOKENS_PREVIEW_FLAG);
